export const VERSIONS_SET_API_VERSION = 'VERSIONS_SET_API_VERSION';

export const setApiVersion = version => ({
    type: VERSIONS_SET_API_VERSION,
    version
});
